import { createSelector } from 'reselect';

import { AppState } from 'redux/reducers';

export const getListViewMarkets = ({ listViewTabs }: AppState) => listViewTabs.listViewMarkets;
export const getListViewTopMarket = ({ listViewTabs }: AppState) => listViewTabs.topMarket;
export const getListViewMarketsTabs = createSelector(getListViewMarkets, markets =>
  markets.map(({ marketId, marketName }) => ({ id: marketId, name: marketName }))
);
